import React from 'react';
import './CourseDetailsSection.css';

function CourseDetailsSection({ course, onClose, detailsSectionRef }) {
    if (!course) return null;

    return (
        <div className="course-details-section" ref={detailsSectionRef}>
            <button className="close-details-button" onClick={onClose}>�</button>
            <h2 className="details-section-title">{course.name}</h2>
            <p className="details-section-overview">{course.overview}</p>

            <div className="workshops-list">
                <h4>Workshops in this Course Package:</h4>
                <ul>
                    {course.workshops.map((workshop, index) => (
                        <li key={index}>{workshop}</li>
                    ))}
                </ul>
            </div>

            <div className="delivery-tiers-container">
                {course.tiers.map(tier => (
                    <div key={tier.name} className="delivery-tier-card">
                        <h3 className="tier-name">{tier.name}</h3>
                        <p className="tier-price">{tier.price}</p>
                        <p className="tier-delivery-mode"><em>{tier.deliveryMode}</em></p>
                        <ul className="tier-features">
                            {tier.features.map(feature => (
                                <li key={feature}>{feature}</li>
                            ))}
                        </ul>
                        <button className="tier-enroll-button">Enroll Now</button>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default CourseDetailsSection;